import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import { LicenseManager } from 'ag-grid-enterprise';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(private router: Router) {
  }

  public ngOnInit() {
    LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-097754}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Chapman_&_Co_Leadership}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{C_&_Co_Portal}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{C_&_Co_Portal}_need_to_be_licensed___{C_&_Co_Portal}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{13_April_2027}____[v3]_[01]_MTgwNzU3MDgwMDAwMA==65312e0a4d2c8a386e5542435d7da664")
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // scroll to top of page when route changes
        window.scrollTo(0, 0);
      }
    });
  }
}
